export default function($) {
  let featuredProducts = document.querySelector('.js-featured-products-slider');
  let lastProducts = document.querySelector('.js-last-products-slider');
  let mobileSwiper = document.querySelector('.js-mobile-slider');
  let initMobileSwiper = false;

  const homeSwiper = new Swiper('.js-home-slider', {
    loop: true,
    slidesPerView: 1,
    speed: 750,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      enabled: false,
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      640: {
        navigation: {
          enabled: true,
        }
      }
    }
  });

  const featuredProductsParams = {
    centeredSlides: true,
    loop: true,
    slidesPerView: 1.2,
    spaceBetween: 32,
    pagination: {
      el: ".featured-products-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
    },
    on: {
      destroy: function() {
        $('.featured-products-swiper-pagination').hide();
      },
      init: function() {
        $('.featured-products-swiper-pagination').show();
      },
    },
  };

  const lastProductsParams = {
    centeredSlides: true,
    loop: true,
    slidesPerView: 1.2,
    spaceBetween: 32,
    pagination: {
      el: ".last-products-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
    },
    on: {
      destroy: function() {
        $('.last-products-swiper-pagination').hide();
      },
      init: function() {
        $('.last-products-swiper-pagination').show();
      },
    },
  };

  const mobileSwiperParams = {
    centeredSlides: true,
    slidesPerView: 1.2,
    spaceBetween: 16,
    pagination: {
      el: ".mobile-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      480: {
        slidesPerView: 1.3,
        spaceBetween: 32,
      },
    },
  };

  swiperDisplay();

  $(window).resize(function() {
    swiperDisplay();
  })

  function swiperDisplay() {
    if( $(window).width() < 1024 ) {
      if( $('.js-featured-products-slider').length > 0 && !featuredProducts.initialized ) {
        featuredProducts = new Swiper('.js-featured-products-slider', featuredProductsParams);
      };
      if( $('.js-last-products-slider').length > 0 && !lastProducts.initialized ) {
        lastProducts = new Swiper('.js-last-products-slider', lastProductsParams);
      };

      if( !initMobileSwiper ) {
        initMobileSwiper = true;

        $('.js-mobile-slider').each(function(index) {
          let sliderDiv = $(this)[0]
          mobileSwiper = new Swiper(sliderDiv, mobileSwiperParams);
        })
      }
    }

    else {
      if( $('.js-featured-products-slider').length > 0 && featuredProducts.initialized ) {
        featuredProducts.destroy(false,true);
        $('.js-featured-products-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('.featured-products-swiper-pagination').hide();
      };

      if( $('.js-last-products-slider').length > 0 && lastProducts.initialized ) {
        lastProducts.destroy(false,true);
        $('.js-last-products-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('.last-products-swiper-pagination').hide();
      };

      if( $('.js-mobile-slider').length) {
        $('.js-mobile-slider').each( function() {
          let sliderDiv = $(this)[0]
          if (sliderDiv.swiper) {
            sliderDiv.swiper.destroy(false,true)
          }
        })

        initMobileSwiper = false
      }
    }
  }
}
